import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabCarouselComponent } from './tab-carousel.component';

@NgModule({
  declarations: [
    TabCarouselComponent
  ],
  imports: [
    CommonModule,
  ],
  providers: [],
  exports: [
    TabCarouselComponent
  ],
})
export class TabCarouselModule { }
